var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.data),function(product,key){return _c('v-flex',{key:key,attrs:{"lg4":""}},[_c('product-item',{attrs:{"data":product,"catid":_vm.catid}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }